// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-game {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n}\n.btn-game span {\n  font-size: 0.6rem;\n}\n@media (min-width: 1024px) {\n.btn-game span {\n    font-size: 1rem;\n}\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
